"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getExemptionRulesWithContext;

var _Rule = _interopRequireDefault(require("./Rule"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // Gets and transforms rules based on filer and case object


function getExemptionRulesWithContext(caseObj, jurisdiction, isResident) {
  // Get base rules
  var rules = _Rule["default"].getBaseRules(jurisdiction, isResident); // Transform rules based on filer and case properties


  rules.forEach(function (rule) {
    return rule.transformFromCaseContext(caseObj);
  });
  return rules;
}